import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { getValidValue, pluck, pluckNumber, getMouseCoordinate, setImageDisplayMode } from '../../../fc-core/src/lib';

var UNDEF,
    NONE = 'none',
    POSITION_TOP = 'top',
    POSITION_BOTTOM = 'bottom',
    POSITION_MIDDLE = 'middle',
    POSITION_RIGHT = 'right',
    POSITION_LEFT = 'left',
    POINTER = 'pointer',
    TL = 'tl',
    NORMAL = 'normal',
    LOGOROLLOUT = 'LogoRollout',
    LOGOROLLOVER = 'LogoRollover',
    LOGOCLICK = 'LogoClick',
    LOGOLOADED = 'LogoLoaded',
    LOGOLOADERROR = 'LogoLoadError',
    defaultPosition = {
  vAlign: 'top',
  hAlign: 'left'
},
    pointerCSS = {
  link: {
    cursor: 'pointer',
    _cursor: 'pointer'
  },
  normal: {
    cursor: 'default',
    _cursor: 'normal'
  }
},
    position = {
  tr: {
    vAlign: 'top',
    hAlign: 'right'
  },
  bl: {
    vAlign: 'bottom',
    hAlign: 'left'
  },
  br: {
    vAlign: 'bottom',
    hAlign: 'right'
  },
  cc: {
    vAlign: 'middle',
    hAlign: 'middle'
  }
},
    isVML = !!(window.SVGAngle || document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1')),
    getHandler = function getHandler(a) {
  var b = a.config;
  return {
    load: function load() {
      var c,
          d = a.getGraphicalElement('logoImage'),
          e = a.getFromEnv('chartConfig'),
          f = e.borderWidth || 0,
          g = a.getFromEnv('chart'),
          h = e.height,
          i = e.width,
          j = b.logoPosition,
          k = b.logoScale,
          l = b.logoLeftMargin,
          m = b.logoTopMargin,
          n = b.logoURL,
          o = b.logoAlpha,
          p = b.logoPositionSTR,
          q = b.logoLink;
      d.show(), c = setImageDisplayMode(NONE, j.vAlign, j.hAlign, k, f, i, h, d._.RefImg), isVML && (c.w = c.width || 0, c.h = c.height || 0), c.transform = 'T' + l + ',' + m, d.attr(c), g.fireChartInstanceEvent(LOGOLOADED, {
        logoURL: n,
        logoAlpha: o,
        logoPosition: p,
        logoScale: k,
        logoLink: q
      });
    },
    error: function error(c) {
      var d = b.logoURL,
          e = b.logoAlpha,
          f = b.logoPositionSTR,
          g = b.logoScale,
          h = b.logoLink,
          i = a.getFromEnv('chart');
      i.fireChartInstanceEvent(LOGOLOADERROR, {
        logoURL: d,
        logoAlpha: e,
        logoPosition: f,
        logoScale: g,
        logoLink: h,
        error: c
      });
    },
    mouseover: function mouseover(c) {
      var d = a.getFromEnv('chartInstance'),
          e = getMouseCoordinate(d.ref, c),
          f = a.getFromEnv('chart'),
          g = b.logoURL,
          h = b.logoAlpha,
          i = b.logoPositionSTR,
          j = b.logoScale,
          k = b.logoLink;
      f.fireChartInstanceEvent(LOGOROLLOVER, {
        logoURL: g,
        logoAlpha: h,
        logoPosition: i || TL,
        logoScale: j,
        logoLink: k,
        chartX: e.chartX,
        chartY: e.chartY,
        pageX: e.pageX,
        pageY: e.pageY
      });
    },
    mouseout: function mouseout(c) {
      var d = a.getFromEnv('chartInstance'),
          e = getMouseCoordinate(d.ref, c),
          f = a.getFromEnv('chart'),
          g = b.logoURL,
          h = b.logoAlpha,
          i = b.logoPositionSTR,
          j = b.logoScale,
          k = b.logoLink;
      f.fireChartInstanceEvent(LOGOROLLOUT, {
        logoURL: g,
        logoAlpha: h,
        logoPosition: i || TL,
        logoScale: j,
        logoLink: k,
        chartX: e.chartX,
        chartY: e.chartY,
        pageX: e.pageX,
        pageY: e.pageY
      });
    },
    click: function click(c) {
      var d = a.getFromEnv('chartInstance'),
          e = getMouseCoordinate(d.ref, c),
          f = a.getFromEnv('chart'),
          g = b.logoURL,
          h = b.logoAlpha,
          i = b.logoPositionSTR,
          j = b.logoScale,
          k = b.logoLink;
      f.fireChartInstanceEvent(LOGOCLICK, {
        logoURL: g,
        logoAlpha: h,
        logoPosition: i || TL,
        logoScale: j,
        logoLink: k,
        chartX: e.chartX,
        chartY: e.chartY,
        pageX: e.pageX,
        pageY: e.pageY
      }, UNDEF, b.linkClickFN);
    }
  };
};

var Logo =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(Logo, _ComponentInterface);

  function Logo() {
    var _this;

    _classCallCheck(this, Logo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Logo).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a.config._context = {}, a.config.handler = getHandler(a), a.config.linkClickFN = function () {
      var b = a.config.logoLink;
      b && a.getFromEnv('linkClickFN').call({
        link: b
      }, !0);
    };
    return _this;
  }

  _createClass(Logo, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = this,
          b = a.config,
          c = a.getFromEnv('chart-attrib');
      b.logoURL = getValidValue(c.logourl, ''), b.logoPositionSTR = pluck(c.logoposition, TL).toLowerCase(), b.logoPosition = position[b.logoPositionSTR] || defaultPosition, b.logoAlpha = pluckNumber(c.logoalpha, 100), b.logoLink = getValidValue(c.logolink), b.logoScale = pluckNumber(c.logoscale, 100), b.logoLeftMargin = pluckNumber(c.logoleftmargin, 0), b.logoTopMargin = pluckNumber(c.logotopmargin, 0), a.setState('dirty', !0);
    }
  }, {
    key: "_contextChanged",
    value: function _contextChanged() {
      var a,
          b = this,
          c = b.config,
          d = b.getFromEnv('chartConfig'),
          e = d.borderWidth,
          f = d.width,
          g = d.height;
      return e !== c._context.chartBorderWidth && (c._context.chartBorderWidth = e, a = !0), f !== c._context.chartWidth && (c._context.chartWidth = f, a = !0), g !== c._context.chartHeight && (c._context.chartHeight = g, a = !0), a;
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this,
          b = a.config,
          c = a.getFromEnv('animationManager'),
          d = a.getGraphicalElement('logoImage'),
          e = a.getLinkedParent().getChildContainer('logoGroup'),
          f = b.logoAlpha,
          g = b.logoURL,
          h = b.logoLink,
          i = !a.getState('removed'),
          j = a._contextChanged();

      i && !(a.getState('dirty') || j) || g && i && (d = c.setAnimation({
        el: d || 'image',
        attr: {
          opacity: .01 * f || 1,
          src: g
        },
        component: a,
        container: e
      }), !a.getGraphicalElement('logoImage') && (a.addGraphicalElement('logoImage', d), d.on('load', b.handler.load), d.on('error', b.handler.error), d.on('fc-click', b.handler.click), d.on('fc-mouseover', b.handler.mouseover), d.on('fc-mouseout', b.handler.mouseout)), d.css(pointerCSS[h ? 'link' : 'normal']));
    }
  }]);

  return Logo;
}(ComponentInterface);

export default Logo;